<template>
  <div class="loginWrap" :class="festivalClass">
    <div class="login-bg" aria-hidden="true">
      <div class="login-bg-photo"></div>
      <div class="login-bg-tint"></div>
    </div>
    <div class="login-bg-shapes" aria-hidden="true">
      <span class="geo g1"></span>
      <span class="geo g2"></span>
      <span class="geo g3"></span>
      <span class="geo g4"></span>
    </div>
    <div class="festival-scene" v-if="festivalKey" aria-hidden="true">
      <div class="fs-sky"></div>
      <div class="fs-mist"></div>
      <div class="fs-moon"></div>
      <div class="fs-hill h1"></div>
      <div class="fs-hill h2"></div>
      <div class="fs-ground"></div>
      <span class="fs-fu">福</span>
      <span class="fs-couplet left">云开锦绣</span>
      <span class="fs-couplet right">岁启华章</span>
      <span class="fs-willow w1"></span>
      <span class="fs-willow w2"></span>
      <span class="fs-bird b1"></span>
      <span class="fs-bird b2"></span>
      <span
          v-for="n in 8"
          :key="'star-' + n"
          class="fs-star"
          :style="starStyle(n)"
      ></span>
      <span
          v-for="n in 6"
          :key="'lantern-' + n"
          class="lantern"
          :style="lanternStyle(n)"
      ><i></i></span>
      <span
          v-for="n in 5"
          :key="'boat-' + n"
          class="fs-boat"
          :style="boatStyle(n)"
      ></span>
      <span
          v-for="n in 22"
          :key="'flake-' + n"
          class="flake"
          :style="flakeStyle(n)"
      ></span>
      <span class="fs-flag fg-left"></span>
      <span class="fs-flag fg-right"></span>
      <span class="fs-burst br1"></span>
      <span class="fs-burst br2"></span>
      <span class="fs-burst br3"></span>
      <div class="festival-badge">{{ festivalLabel }}</div>
    </div>
    <header class="login-header">
      <div class="brand">
        <span class="brand-mark">
          <img :src="brandLogo" alt="" />
        </span>
        <span class="brand-name">{{ $t("brand.name") }}</span>
      </div>
      <LanguageSwitch />
    </header>
    <div class="login-main">
      <section class="login-card">
        <div class="tabs" v-if="activeLoginRole === 'bindPhone'">
          <div class="loginMethod activeMethod">
            <div>{{ $t("login.bindPhone") }}</div>
            <div class="line"/>
          </div>
        </div>
        <div class="tabs" v-else-if="loginPanel === 'password'">
          <template v-if="passwordRole === 'user'">
            <div
                :class="['loginMethod', userAuthType == t.key && 'activeMethod']"
                v-for="t in userAuthTabs"
                :key="t.key"
                @click="userAuthType = t.key"
            >
              <div>{{ t.text }}</div>
              <div class="line" v-if="userAuthType == t.key"/>
            </div>
          </template>
          <div class="loginMethod activeMethod" v-else>
            <div>{{ $t("login.adminLogin") }}</div>
            <div class="line"/>
          </div>
        </div>
        <div class="tabs" v-else-if="loginPanel === 'wechat'">
          <div class="loginMethod activeMethod">
            <div>{{ $t("login.wechatLogin") }}</div>
            <div class="line"/>
          </div>
        </div>

        <el-form
            :model="activeFormModel"
            :rules="activeFormRules"
            ref="loginForm"
            v-if="loginPanel === 'password' || activeLoginRole === 'bindPhone'"
            @submit.native.prevent="handleFormSubmit"
        >
          <el-form-item
              v-for="f in activeFormItems"
              :key="f.key"
              :prop="f.key"
          >
            <el-input
                v-model="activeFormModel[f.key]"
                :placeholder="$tt(f.placeholder)"
                :show-password="f.key == 'password'"
                @keyup.enter.native="handleFormSubmit"
            >
              <el-button
                  slot="append"
                  type="primary"
                  v-if="f.key == 'sms_code'"
                  @click="sendVerifyCode"
              >
                {{ showTimeCount ? `${timeCount}${$t("login.seconds")}` : $t("login.sendCode") }}
              </el-button>
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button
                type="primary"
                class="loginBtn"
                native-type="submit"
            >
              {{ activeLoginRole == "bindPhone" ? $t("login.bind") : $t("login.loginNow") }}
            </el-button>
          </el-form-item>
        </el-form>
        <div id="qrcode" v-if="loginPanel === 'wechat' && activeLoginRole !== 'bindPhone'">
          <img :src="qrCodeSrc" v-if="qrCodeSrc"/>
          <p class="qr-tip">{{ $t("login.wechatTip") }}</p>
        </div>
        <div class="login-extra" v-if="activeLoginRole !== 'bindPhone' && loginPanel === 'password'">
          <a v-if="passwordRole === 'user'" @click="$router.push('/register')">{{ $t("login.register") }}</a>
          <a v-if="passwordRole === 'user'" @click="passwordRole = 'admin'">{{ $t("login.adminEntry") }}</a>
          <a v-else @click="passwordRole = 'user'">{{ $t("login.backUser") }}</a>
        </div>
        <div class="login-wechat-entry" v-if="activeLoginRole !== 'bindPhone'">
          <button
              v-if="loginPanel === 'password'"
              type="button"
              class="wechat-icon-btn"
              :title="$t('login.wechatLogin')"
              @click="switchToWechat"
          >
            <img :src="wechatIcon" alt="WeChat" class="wechat-icon-img" />
          </button>
          <a v-else @click="switchToPassword">{{ $t("login.backAccount") }}</a>
          <p class="wechat-entry-label">{{ $t("login.thirdPartyLogin") }}</p>
        </div>
      </section>
      <section class="login-promo">
        <h1 class="promo-title">{{ $t("brand.name") }}</h1>
        <p class="promo-sub">{{ $t("login.promoSub") }}</p>
        <ul class="promo-list">
          <li>{{ $t("login.promo1") }}</li>
          <li>{{ $t("login.promo2") }}</li>
          <li>{{ $t("login.promo3") }}</li>
        </ul>
        <div class="client-download-panel">
          <ClientDownloadHub layout="login" :welcome-list="clientWelcomeList" />
        </div>
      </section>
    </div>
    <footer class="login-copyright">
      Copyright © {{ copyrightRange }} wird.com.cn All Rights Reserved.
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">京ICP备2022001046号-1</a>
      <span v-if="appVersion">v{{ appVersion }}</span>
    </footer>
  </div>
</template>

<script>
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import ClientDownloadHub from "@/components/ClientDownloadHub.vue";
import {isNeedChangePassword} from "@/utils/account";

import "./index.scss";
import {setCookie} from '@/utils/utils';
import brandLogo from '@/assets/logo-main-new.png';
import wechatIcon from '@/assets/wechat.svg';
import {
  detectFestival,
  fetchNetworkNow,
  fetchAppVersion,
  runningAppVersion,
  FESTIVAL_LABELS,
} from '@/utils/festivalTheme';
export default {
  components: { LanguageSwitch, ClientDownloadHub },
  data() {
    return {
      clientWelcomeList: [],
      brandLogo,
      wechatIcon,
      loginPanel: "password",
      passwordRole: "user",
      userAuthType: "password",
      loginMethodsModel: {
        passwordWay: {
          login_name: "",
          password: "",
        },
        userPasswordWay: {
          phone: "",
          password: "",
        },
        phoneNumberWay: {
          phone: "",
          sms_code: "",
        },
        bindPhoneNumber: {
          phone: "",
          sms_code: "",
        },
      },
      activeLoginRole: "main",
      qrCodeSrc: "",
      showTimeCount: false,
      timeCount: 60,
      temporaryUserData: {},
      festivalKey: "",
      appVersion: runningAppVersion(),
      copyrightYear: new Date().getFullYear(),
    };
  },
  computed: {
    userAuthTabs() {
      return [
        { text: this.$t("login.passwordLogin"), key: "password" },
        { text: this.$t("login.smsLogin"), key: "sms" },
      ];
    },
    loginMethodsFormItems() {
      return {
        passwordWay: [
          { key: "login_name", placeholder: this.$t("login.username"), icon: "el-icon-user" },
          { key: "password", placeholder: this.$t("login.password"), icon: "el-icon-lock" },
        ],
        userPasswordWay: [
          { key: "phone", placeholder: this.$t("login.phone"), icon: "el-icon-mobile-phone" },
          { key: "password", placeholder: this.$t("login.password"), icon: "el-icon-lock" },
        ],
        phoneNumberWay: [
          { key: "phone", placeholder: this.$t("login.phone"), icon: "el-icon-mobile-phone" },
          { key: "sms_code", placeholder: this.$t("login.sms"), icon: "el-icon-chat-dot-round" },
        ],
        bindPhoneNumber: [
          { key: "phone", placeholder: this.$t("login.phone"), icon: "el-icon-mobile-phone" },
          { key: "sms_code", placeholder: this.$t("login.sms"), icon: "el-icon-chat-dot-round" },
        ],
      };
    },
    formRules() {
      return {
        passwordWay: {
          login_name: [{ required: true, message: this.$t("login.username"), trigger: "blur" }],
          password: [{ required: true, message: this.$t("login.password"), trigger: "blur" }],
        },
        userPasswordWay: {
          phone: [{ required: true, message: this.$t("login.phone"), trigger: "blur" }],
          password: [{ required: true, message: this.$t("login.password"), trigger: "blur" }],
        },
        phoneNumberWay: {
          phone: [{ required: true, message: this.$t("login.phone"), trigger: "blur" }],
          sms_code: [{ required: true, message: this.$t("login.sms"), trigger: "blur" }],
        },
        bindPhoneNumber: {
          phone: [{ required: true, message: this.$t("login.phone"), trigger: "blur" }],
          sms_code: [{ required: true, message: this.$t("login.sms"), trigger: "blur" }],
        },
      };
    },
    currentFormKey() {
      if (this.activeLoginRole === "bindPhone") {
        return "bindPhoneNumber";
      }
      if (this.passwordRole === "admin") {
        return "passwordWay";
      }
      return this.userAuthType === "sms" ? "phoneNumberWay" : "userPasswordWay";
    },
    activeFormModel() {
      return this.loginMethodsModel[this.currentFormKey];
    },
    activeFormRules() {
      return this.formRules[this.currentFormKey];
    },
    activeFormItems() {
      return this.loginMethodsFormItems[this.currentFormKey];
    },
    festivalClass() {
      return this.festivalKey ? "festival-" + this.festivalKey : "";
    },
    festivalLabel() {
      return FESTIVAL_LABELS[this.festivalKey] || "";
    },
    copyrightRange() {
      const start = 2022;
      const year = Number(this.copyrightYear) || start;
      const end = year > start ? year : start;
      return start + " - " + end;
    },
  },
  created() {
    this.initFestivalTheme();
    this.loadClientDownloads();
  },
  watch: {
    loginPanel(v) {
      if (v == "wechat") {
        this.createQrPic();
      } else {
        clearInterval(this.checkInterval);
      }
      this.initTimeCount();
    },
    userAuthType() {
      this.initTimeCount();
    },
    activeLoginRole(v) {
      if (v === "bindPhone") {
        this.loginPanel = "password";
      }
    },
  },
  methods: {
    flakeStyle(n) {
      return {
        left: ((n * 17) % 94) + 2 + "%",
        animationDelay: -n * 0.48 + "s",
        animationDuration: 7.2 + (n % 6) * 1.05 + "s",
      };
    },
    lanternStyle(n) {
      const lefts = [4, 14, 24, 72, 84, 92];
      return {
        left: lefts[n - 1] + "%",
        animationDelay: -n * 0.45 + "s",
        animationDuration: 3.1 + n * 0.22 + "s",
      };
    },
    starStyle(n) {
      return {
        left: ((n * 23) % 90) + 4 + "%",
        top: 8 + (n % 5) * 7 + "%",
        animationDelay: -n * 0.7 + "s",
      };
    },
    boatStyle(n) {
      return {
        left: n * 16 + 4 + "%",
        animationDelay: -n * 1.1 + "s",
        animationDuration: 10 + n * 1.4 + "s",
      };
    },
    initFestivalTheme() {
      fetchAppVersion().then((v) => {
        if (v) {
          this.appVersion = v;
        }
      });
      fetchNetworkNow().then((now) => {
        if (now && !Number.isNaN(now.getTime())) {
          this.copyrightYear = now.getFullYear();
        }
        const preview = String((this.$route && this.$route.query && this.$route.query.festival) || "");
        const allowed = [
          "chunjie",
          "xiaonian",
          "yuanxiao",
          "qingming",
          "duanwu",
          "qixi",
          "zhongyuan",
          "chongyang",
          "laba",
          "zhongqiu",
          "guoqing",
        ];
        if (allowed.indexOf(preview) !== -1) {
          this.festivalKey = preview;
          return;
        }
        this.festivalKey = detectFestival(now);
      });
    },
    loadClientDownloads() {
      this.$request
        .getDownloadList({})
        .then((res) => {
          if (res.status !== "success") {
            return;
          }
          this.clientWelcomeList = res.data || [];
        })
        .catch(() => {});
    },
    handleFormSubmit() {
      if (this.activeLoginRole === "bindPhone") {
        this.bindPhoneFunc();
        return;
      }
      this.login();
    },
    switchToWechat() {
      this.loginPanel = "wechat";
    },
    switchToPassword() {
      this.loginPanel = "password";
      this.activeLoginRole = "main";
    },
    createQrPic() {
      this.$request.getQrCode({}).then((res) => {
        if (res.status != "success") {
          this.$message.error(res.msg);
          return;
        }
        const {event_key, qrcode_url} = res.data || {};
        this.pollingQrKey = event_key;
        this.qrCodeSrc = qrcode_url;
        this.$nextTick(() => {
          this.checkInterval = setInterval(() => {
            this.$request.checkIsCodeLogin({event_key}).then((res) => {
              if (res.status != "success") {
                return;
              }
              if (!res?.data?.phone) {
                //清除定时器
                clearInterval(this.checkInterval);
                this.activeLoginRole = "bindPhone";
                this.temporaryUserData = res.data || {};
                return;
              }
              if (res?.data?.token) {
                this.saveUserInfo(res.data || {});
                clearInterval(this.checkInterval);
              }
            });
          }, 3000);
        });
      });
    },
    getUserAuthorizedMenus(user_id) {
      this.$request
          .getUserAuthorizedMenus({
            user_id,
          })
          .then((res) => {
            if (res.status != "success") {
              this.$message.error(res.msg);
              return;
            }
            this.$store.commit("setAuthorizedMenus", {
              data: res?.data?.children || [],
              donotJump: isNeedChangePassword(this.$store.state.loginAccountInfo),
            });
          });
    },
    saveUserInfo(data) {
      this.$store.commit("setLoginAccountInfo", data);
      setCookie("loginAccountInfo", JSON.stringify(data), 7 * 24 * 60 * 60 * 1000);
      if (isNeedChangePassword(data)) {
        this.$router.push("/personal");
        this.getUserAuthorizedMenus(data.user_id);
        return;
      }
      this.getUserAuthorizedMenus(data.user_id);
    },
    login() {
      const form = this.$refs.loginForm;
      if (!form) {
        return;
      }
      form.validate((valid) => {
        if (!valid) {
          return;
        }
        const key = this.currentFormKey;
        const api =
          key === "userPasswordWay"
            ? "userPasswordLogin"
            : key === "phoneNumberWay"
            ? "phoneNumberWay"
            : "passwordWay";
        this.$request[api]({
          ...this.loginMethodsModel[key],
        }).then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.saveUserInfo(res.data || {});
        });
      });
    },
    bindPhoneFunc() {
      this.$request
          .bindPhoneNumber({
            event_key: this.pollingQrKey,
            ...this.loginMethodsModel.bindPhoneNumber,
          })
          .then((res) => {
            if (res.status != "success") {
              this.$message.error(res.msg);
              return;
            }
            this.saveUserInfo(this.temporaryUserData);
            this.activeLoginRole = "main";
          });
    },
    initTimeCount() {
      clearInterval(this.timeCountInterval);
      this.showTimeCount = false;
      this.timeCount = 60;
    },
    sendVerifyCode() {
      if (this.showTimeCount) return;
      const phone = this.activeFormModel && this.activeFormModel.phone;
      this.$request
          .getLoginVerifyCode({
            phone,
          })
          .then((res) => {
            if (res.status != "success") {
              this.$message.error(res.msg);
              return;
            }
            this.showTimeCount = true;
            this.timeCountInterval = setInterval(() => {
              if (this.timeCount == 0) {
                this.initTimeCount();
              }
              this.timeCount = this.timeCount - 1;
            }, 1000);
            this.$message.success(this.$t("common.sendSuccess"));
          });
    },
  },
  beforeDestroy() {
    clearInterval(this.checkInterval);
    clearInterval(this.timeCountInterval);
  },
};
</script>

<style lang="scss">
</style>